import * as SYSTEM from '@/constant/system/code'
import * as ResourcesApi from '@/api/system/sys-resources'
import * as PostApi from '@/api/system/post'
import { constant2Option } from '@/utils/common'
/**
 * 系统功能下拉框加载器
 *
 * @author Jay Qing
 */

/**
 * 用户状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const USER_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.USER_STATUS))
  }
}

/**
 * 用户性别
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const USER_GENDER = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.USER_GENDER))
  }
}

/**
 * 角色状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const ROLE_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.USER_STATUS))
  }
}

/**
 * 部门状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const DEPARTMENT_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.DEPARTMENT_STATUS))
  }
}

/**
 * 菜单状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const MENU_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.MENU_STATUS))
  }
}

/**
 * 菜单操作装填
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const MENU_ACTION_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.MENU_ACTION_STATUS))
  }
}

/**
 * 菜单类型
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const MENU_TYPE = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.MENU_TYPE))
  }
}

/**
 * 菜单可见性
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const MENU_VISIBILITY = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.MENU_VISIBILITY))
  }
}

/**
 * 菜单可见性
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const MENU_KEEP_ALIVE = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.MENU_KEEP_ALIVE))
  }
}

/**
 * 字典状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const DICTIONARY_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.DICTIONARY_STATUS))
  }
}

/**
 * 字典数据状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const DICTIONARY_DATA_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.DICTIONARY_DATA_STATUS))
  }
}

/**
 * 任务状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const JOB_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.JOB_STATUS))
  }
}

/**
 * 任务运行结果
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const JOB_RUN_RESULT = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.JOB_RUN_RESULT))
  }
}

/**
 * 任务日志策略
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const JOB_LOG_STRATEGY = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.JOB_LOG_STRATEGY))
  }
}

/**
 * 邮件类型
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const MAIL_TYPE = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.MAIL_TYPE))
  }
}

/**
 * 公告/消息类型
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const MESSAGE_TYPE = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.MESSAGE_TYPE))
  }
}

/**
 * 公告/消息状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const MESSAGE_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.MESSAGE_STATUS))
  }
}

/**
 * 公告/消息阅读状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const MESSAGE_READ_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.MESSAGE_READ_STATUS))
  }
}

/**
 * 任务状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const ASYN_TASK_STATUS = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.ASYN_TASK_STATUS))
  }
}

/**
 * 客户端资源类型
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const RESOURCES_TYPE = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.RESOURCES_TYPE))
  }
}

/**
 * 日志请求状态
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const LOG_RESULT_TYPE = {
  request: function() {
    return Promise.resolve(constant2Option(SYSTEM.LOG_RESULT_TYPE))
  }
}

/**
 * 所有启用的资源
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const ENABLE_RESOURCES = {
  labelKey: 'resourcesName',
  valueKey: 'id',
  request: function() {
    return ResourcesApi.listEnableResources().then(res => {
      return res.data
    })
  }
}
/**
 * 所有启用的岗位
 *
 * @type {{request: (function(): Promise<[]>)}}
 */
export const ENABLE_POST = {
  labelKey: 'postName',
  valueKey: 'id',
  request: function() {
    return PostApi.list().then(res => {
      return res.data
    })
  }
}
